import { IDocumentTokenDto } from "@/models/document-token.entity";
import { VuetifyMaterialColorEnum } from "@/lib/enum/vuetify-color.enum";
import { BaseTokenEntity } from "./base-token.entity";

export class CheckboxTokenEntity extends BaseTokenEntity {
  static readonly token = "X";
  static readonly CHECKED_VALUE = "x";
  static readonly UNCHECKED_VALUE = "";

  private static readonly PT_TO_MM = 25.4 / 72;

  fontSize: number;

  constructor(
    data: Partial<CheckboxTokenEntity> & {
      x: number;
      y: number;
      w?: number;
      h?: number;
    }
  ) {
    super(data);
    this.fontSize = data.fontSize ?? 12;
  }

  get tokenString() {
    return CheckboxTokenEntity.token;
  }

  get colorHex() {
    return VuetifyMaterialColorEnum.GREY_DARKEN_1;
  }

  get icon() {
    return "mdi-checkbox-marked-outline";
  }

  get color() {
    return "grey darken-1";
  }

  get labelKey() {
    return "sign.fieldType.checkbox";
  }

  get defaultSize() {
    return { w: 0.02, h: 0.02 };
  }

  get fixedSize() {
    return false;
  }

  validateConstraints(pageWidthMm?: number, pageHeightMm?: number) {
    if (!pageWidthMm || !pageHeightMm) return;
    const size = (this.fontSize ?? 12) * CheckboxTokenEntity.PT_TO_MM;
    const w = size / pageWidthMm;
    const h = size / pageHeightMm;
    this.centerBounds(w, h);
  }

  toDto(widthPx: number, heightPx: number): IDocumentTokenDto {
    return this.buildDto(widthPx, heightPx, this.fontSize);
  }
}
